import { render, staticRenderFns } from "./PatientsInCare.vue?vue&type=template&id=58129346&"
import script from "./PatientsInCare.vue?vue&type=script&lang=js&"
export * from "./PatientsInCare.vue?vue&type=script&lang=js&"
import style0 from "./PatientsInCare.vue?vue&type=style&index=0&id=58129346&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports